import { DownOutlined, UpOutlined } from '@ant-design/icons'
import { AppButton } from '@components/AppComponents'
import { TableFilterContext } from '@components/table/TableContext'
import { checkIsJSON } from '@utils/functions'
import { toJS } from 'mobx'
import React, { useContext, useMemo } from 'react'

interface FilterButtonProps {
  filter: any
  onPress?: Function
  filterCount?: number
}
const UN_COUNT = [
  'skipCount',
  'maxResultCount',
  'serviceType',
  'isCountOnly',
  'showBookingToday',
]

const FilterButton = ({
  filter = {},
  filterCount,
  onPress,
}: FilterButtonProps) => {
  const defaultFilter = React.useMemo(() => filter, [])

  const filterContext = useContext(TableFilterContext)

  const count = React.useMemo(() => {
    // const jsonData = toJS(filter)
    let count = 0
    Object.keys(filter)
      .filter(key => !UN_COUNT.includes(key))
      .forEach(key => {
        // let defaultValue = checkIsJSON(defaultFilter[key]) ? JSON.parse(defaultFilter[key]) : defaultFilter[key]
        let filterValue = filter[key]

        // validate other filter values
        // if (Array.isArray(defaultValue)) {
        //   defaultValue = JSON.stringify(defaultValue)
        // }

        if (Array.isArray(filterValue) && filterValue.length > 0) {
          count++
        } else {
          if (filterValue !== null && filterValue != '') {
            count++
          }
        }
      })
    return count
  }, [defaultFilter, filter])

  const handleClickFilter = () => {
    const isShow = !filterContext.isShowFilterSection
    filterContext.setShowFilterSection(isShow)
    if (onPress) {
      onPress(isShow)
    }
  }

  const filterCountValue = useMemo(() => {
    if (filterCount !== undefined) {
      return filterCount
    }
    return count
  }, [count, filterCount])

  return (
    <AppButton
      onClick={handleClickFilter}
      className="flex items-center justify-center"
    >
      <span>
        Filters
        {/* {`${filterCountValue ? `(${filterCountValue})` : ''}`} */}
      </span>
      {filterContext.isShowFilterSection ? (
        <UpOutlined className="inline" width="14" height="14" />
      ) : (
        <DownOutlined className="inline" width="14" height="14" />
      )}
    </AppButton>
  )
}

export default FilterButton
